import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "booking-basket__spinner"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "mobile-header"
}
const _hoisted_4 = {
  key: 0,
  class: "mobile-header__total"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "booking-basket__main" }
const _hoisted_7 = { class: "total" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "price pre-paid"
}
const _hoisted_12 = {
  key: 1,
  class: "price"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  class: "booking-basket__alert-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BookingBasketHeadDetail = _resolveComponent("BookingBasketHeadDetail")!
  const _component_BookingBasketSection = _resolveComponent("BookingBasketSection")!
  const _component_BookingBasketExtras = _resolveComponent("BookingBasketExtras")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!

  return (_openBlock(), _createElementBlock("section", {
    key: _ctx.bookingSections.length,
    class: _normalizeClass(["booking-basket", { basket: _ctx.renderBasketContainer }])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_BaseSpinner, { size: 40 })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("header", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("basket.title")), 1),
      (_ctx.bookingSummary.bookingNumber > 0)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.bookingSummary.bookingNumber), 1))
        : _createCommentVNode("", true),
      (_ctx.renderBasketContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.bookingSummary.totalPrice > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(_ctx.bookingSummary.totalPrice.toFixed(2)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "-")),
            (_ctx.renderBasketContainer)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 2,
                  class: _normalizeClass(["button--white mobile-header__btn", {expanded: _ctx.expanded}])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BaseSvg, { icon: "chevron/chevron-circle-up" })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_BaseExpansion, {
      expanded: _ctx.expanded || _ctx.largeScreen || !_ctx.renderBasketContainer
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BookingBasketHeadDetail, {
            passengers: _ctx.bookingSummary.passengers,
            modeOfTravel: _ctx.modeOfTravel,
            serviceType: _ctx.tripType,
            campaign: _ctx.bookingSummary.campaignName
          }, null, 8, ["passengers", "modeOfTravel", "serviceType", "campaign"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingSections, (section, index) => {
            return (_openBlock(), _createBlock(_component_BookingBasketSection, {
              class: "basket-section",
              key: index,
              currency: _ctx.bookingSummary.currency,
              bookingSection: section,
              direction: index < 1 ? _ctx.DirectionEnum.Outward : _ctx.DirectionEnum.Return,
              displayTime: _ctx.bookingSummary.displayTime
            }, null, 8, ["currency", "bookingSection", "direction", "displayTime"]))
          }), 128)),
          (_ctx.bookingSummary.extras?.length > 0)
            ? (_openBlock(), _createBlock(_component_BookingBasketExtras, {
                key: 0,
                extras: _ctx.bookingSummary.extras,
                currency: _ctx.bookingSummary.currency,
                class: "basket-section"
              }, null, 8, ["extras", "currency"]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Total", -1)),
                (_ctx.bookingSummary.totalPrice > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(_ctx.bookingSummary.totalPrice.toFixed(2)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
              ]),
              (_ctx.displayDetailedPayment)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "Prepaid", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(_ctx.bookingSummary.paid.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.displayDetailedPayment)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    (_ctx.bookingSummary.leftToPay >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "To pay"))
                      : _createCommentVNode("", true),
                    (_ctx.bookingSummary.leftToPay < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "To refund"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.bookingSummary.currency) + " " + _toDisplayString(Math.abs(_ctx.bookingSummary.leftToPay).toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.displayCalculatePaymentAlert)
            ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                _createVNode(_component_BaseAlert, {
                  type: "info",
                  message: _ctx.$t('messages.calculatePayment')
                }, null, 8, ["message"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["expanded"])
  ], 2))
}